/*eslint-disable*/
export default hgg_navbar => {
  let $hgg_navbar = $(hgg_navbar)
  let announcementBar = $('.announcement-bar')

  if (announcementBar.length) {
    $('.hgg-top-nav').addClass('lowered')
  }

  if (document.querySelector('body').classList.contains('template-article')) {
    let article_href = window.location.pathname.split('magazine/')[1]
    $hgg_navbar.find(`.js-nav-category[data-magazine-href=${article_href}]`).addClass('selected')
    $hgg_navbar.find('.js-nav-category').each((idxr, chapter) => $(chapter).click((e) => window.location.href = ($(e.target).data('magazine-href'))))
  }
}


// WEBPACK FOOTER //
// ./src/scripts/components/holiday-gift-guide-20-nav-selection.js